import type { AxiosError } from 'axios';
import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';

interface UseErrorBoundaryValues {
  APIError?: AxiosError;
}

interface ErrorBoundaryFunctions {
  setAPIError: (APIError: UseErrorBoundaryValues['APIError']) => void;
}

type ErrorBoundaryStore = UseErrorBoundaryValues & ErrorBoundaryFunctions;

export const useErrorBoundaryStore: UseBoundStore<
  StoreApi<ErrorBoundaryStore>
> = create<ErrorBoundaryStore>()((set) => ({
  setAPIError: (APIError) => set({ APIError }),
  APIError: undefined,
}));
